import React, { Component } from 'react';
import { Icon, Label, Button, Table } from 'semantic-ui-react';
import axios from 'axios'
import { serverIp, toCurrency, firebaseAuth, logComponentLoad } from '../../../../config/constants';
import { checkAdminEmail } from '../algoliaDashboard/AlgoliaMiscUtils';
import { SingleDatePicker } from 'react-dates';
import * as UiConsts from '../../../../config/UiConstants';
import RegularPaymentsTableCell from './RegularPaymentsTableCell';

class PayAllowances extends Component {
    constructor(props) {
        super(props);
        this.state = {
            allowanceList: [],
        }
    }

    
    componentDidMount() {
        console.log("cpx1 ======componentDidMount");

        this.removeListener = firebaseAuth().onAuthStateChanged((user) => {
            console.log("elx1 +++++++++:removeListener");

            if (user) {
                console.log("maddx241 user is:" + user.email);

                if (user.email) {
                    console.log("addx290 user.email  is:" + user.email);
                    this.setState({
                        user: user
                    })

                    //CHECK ALGOLIA FOR USER
                    checkAdminEmail(user.email, this.setAdminResult)
                }

            } else {
                console.log("rlx121 user NOT found");
                this.setState({
                    authed: false,
                    // loading: false,
                    user: user,
                    uid: user.uid
                })
            }
        })

    }

    setAdminResult = (returnObject) => {
        console.log("++++++ addx294 setAdminResult");
        //console.log("addx2941 returnObject:" + JSON.stringify(returnObject, null, 3));

        this.setState({
            algoliaUser: returnObject.algoliaUser,
            //isAdmin: returnObject.isAdmin,
        })

        if (returnObject.algoliaUser.perms.includes("payAllowances")) {
            logComponentLoad(returnObject, "PayAllowances");

            this.getAllowanceList();
        } else {
            logComponentLoad(returnObject, "FAILED - PayAllowances");
        }

    }

    dateSelectOnChange = (date) => {
        console.log("++++++++:dateSelectOnChange");
        console.log("date:" + date);
        console.log("date.getValue():" + date.valueOf());
        this.setState({
            date: date,
            dateNum: date.valueOf(),
            dateString: date.format('dddd MMMM Do')
        })
    }

    getAllowanceList = () => {
        console.log("cpx1 ======getAllowanceList");

        this.setState({ loading: true })

        axios.post(serverIp + 'billing/getAllowanceList', {
            apiKey: this.state.algoliaUser.apiKey,
            enteredBy: this.state.user.email,
            allowanceType: "weekly_allowance",
            body: "ivanmworozi@gmail.com",
            submittedBy: "postman"
        })
            .then((response) => {
                this.setState({ loading: false })
                console.log(JSON.stringify(response.data, null, 3));

                if (response.data.result) {
                    console.log("true.. setting coupon");

                    this.setState({ allowanceList: response.data.weeklyAllowanceList });

                } else {
                    console.log("FAILED");
                    alert("FAILED TO get getAllowanceList:");
                }
            })
            .catch((error) => {
                console.log(error);
                this.setState({
                    loading: false
                })
            });
    }

    payAllowanceList = () => {
        console.log("alx1 ======payAllowanceList");


        if (this.state.dateNum == undefined) {
            alert("no date sent")
        } else if (this.state.allowanceList.length < 1) {
            alert("allowance list is empty");
        } else {
            console.log("alx12 allowanceList:" + JSON.stringify(this.state.allowanceList, null, 3))

            this.setState({ loading: true })

            axios.post(serverIp + 'billing/payAllowanceList', {
                apiKey: this.state.algoliaUser.apiKey,
                enteredBy: this.state.user.email,
                allowanceType: "weekly_allowance",
                dateToBePaid: this.state.dateNum,
                weeklyAllowanceList: this.state.allowanceList
            })
                .then((response) => {
                    this.setState({ loading: false })
                    console.log(JSON.stringify(response.data, null, 3));

                    if (response.data.result) {
                        console.log("true.. setting coupon");

                        this.setState({ allowanceListPaid: true });

                    } else {
                        console.log("FAILED");
                        alert("FAILED TO payAllowanceList:");
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.setState({
                        loading: false
                    })
                });
        }
    }

    getImageLink = (idshirTypes, imageLink) => {
        console.log("alx2 got idshirTypes:"+idshirTypes);
        console.log("alx21 got imageLink:"+imageLink);

        let tempArray = this.state.allowanceList;

        for (var i in tempArray) {
            if (tempArray[i].idshirTypes == idshirTypes) {
                tempArray[i].imageLink = imageLink;
                console.log("found in:"+tempArray[i].shirtTypeName);
               break; //Stop this loop, we found it!
            }
          }

          //NEW ARRAY
          console.log("alx22 new array:"+JSON.stringify(tempArray,null,3));

          this.setState({
              allowanceList: tempArray
          })
    }
    render() {

        const tableRow = this.state.allowanceList.length > 0
            ? this.state.allowanceList.map((allowance) =>
            // <Table.Row>
            //     <RegularPaymentsTableCell allowance={allowance}/>
            // </Table.Row>
            
                <Table.Row>
                    <Table.Cell> {allowance.idshirtTypesDisplay} </Table.Cell>
                    <Table.Cell positive>{allowance.shirtTypeToShow}</Table.Cell>
                    <Table.Cell error>{allowance.shirtTypeName}</Table.Cell>
                    <Table.Cell>{allowance.idshirTypes}</Table.Cell>
                    <Table.Cell>{allowance.itemId}</Table.Cell>
                    <Table.Cell>{toCurrency(allowance.shirttypebuycost)}</Table.Cell>
                    <Table.Cell><RegularPaymentsTableCell allowance={allowance} getImageLink={this.getImageLink} /></Table.Cell>
                </Table.Row>
                )
            : ''

        const buttonUI = this.state.allowanceList.length > 0
            ? <Button color='red' onClick={this.payAllowanceList}> Pay Allowances </Button>
            : <h3>list is empty</h3>

        return (this.state.loading ? <UiConsts.LoadingComponent /> : <div>

            <SingleDatePicker
                date={this.state.date} // momentPropTypes.momentObj or null
                //onDateChange={date => this.setState({ date })} // PropTypes.func.isRequired
                onDateChange={date => this.dateSelectOnChange(date)} // PropTypes.func.isRequired
                focused={this.state.focused} // PropTypes.bool
                isOutsideRange={() => false}
                onFocusChange={({ focused }) => this.setState({ focused })} // PropTypes.func.isRequired
            />
            <h2>{this.state.dateString}</h2>

            <Table celled>
                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>idshirtTypesDisplay</Table.HeaderCell>
                        <Table.HeaderCell>shirtTypeToShow</Table.HeaderCell>
                        <Table.HeaderCell>shirtTypeName</Table.HeaderCell>
                        <Table.HeaderCell>idshirTypes</Table.HeaderCell>
                        <Table.HeaderCell>Phone</Table.HeaderCell>
                        <Table.HeaderCell>shirttypebuycost</Table.HeaderCell>
                        <Table.HeaderCell>Upload Image</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {tableRow}
                </Table.Body>

            </Table>

            {buttonUI}
        </div>);
    }
}

export default PayAllowances;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/Allowances/PayAllowances.js